<template lang="pug">
.linkWrapper.gap-2.align-items-center
  input.link(
    :value='props.text',
    type='submit',
    :aria-label="props.ariaLabel || props.text",
    v-bind="$attrs",
    :class="$attrs.class"
    @click="handleClick"
  )
  slot(name="icon")
</template>

<script setup lang="ts">
import { type InputInteractiveProps } from './InputInteractive.types';
import { inputInteractiveDefaults } from './InputInteractive.defaults';

const props = withDefaults(
  defineProps<InputInteractiveProps>(),
  inputInteractiveDefaults,
);

function handleClick(event: Event) {
  if (props.isDisabled) {
    event.preventDefault();
  }
}
</script>
